import { toastService } from "../../../component/common/toast-messages/toast";
import * as requestFromServer from "./termsAndConditionsApis";


// terms-and-conditions -> create terms-and-conditions api
export const createTermsAndConditionsAction = (dataToBeSent, dataToBeSentForPayload) => async (dispatch) => {
    const response = await requestFromServer.createTermsAndConditions(dataToBeSent, dataToBeSentForPayload);
    if (response) {
      toastService.success(response?.message);
      return response;
    }
};
